webpackJsonp([104101334113578],{

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PostIcons = __webpack_require__(87);
	
	var _PostIcons2 = _interopRequireDefault(_PostIcons);
	
	var _index = __webpack_require__(427);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home(_ref) {
	    var group = _ref.group;
	    return Glamor.createElement(
	        "section",
	        { className: "row posts-loop " },
	        group.map(function (_ref2) {
	            var node = _ref2.node;
	            return Glamor.createElement(
	                "div",
	                { className: "post-wrapper col-12", key: node.slug },
	                Glamor.createElement(
	                    "article",
	                    { className: "list-post post type-post status-publish format-standard hentry" },
	                    Glamor.createElement(
	                        "div",
	                        { className: "entry-header" },
	                        Glamor.createElement(_PostIcons2.default, { node: node, className: "entry-meta" }),
	                        Glamor.createElement(
	                            "h2",
	                            { className: "entry-title" },
	                            Glamor.createElement(_gatsbyLink2.default, { to: "/" + node.slug, dangerouslySetInnerHTML: { __html: node.title } })
	                        )
	                    ),
	                    Glamor.createElement(
	                        "div",
	                        { className: "entry-summary" },
	                        Glamor.createElement("span", { dangerouslySetInnerHTML: { __html: node.body.childMarkdownRemark.excerpt + ' [...] ' } }),
	                        Glamor.createElement(
	                            "span",
	                            { className: "read-more-link" },
	                            Glamor.createElement(
	                                _gatsbyLink2.default,
	                                { to: "/" + node.slug, className: "read-more" },
	                                "Read More"
	                            )
	                        )
	                    )
	                )
	            );
	        })
	    );
	};
	
	exports.default = (0, _index2.default)(Home);
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _hoistNonReactStatics = __webpack_require__(291);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLink = function NavLink(props) {
	    return Glamor.createElement(
	        _gatsbyLink2.default,
	        { to: props.url },
	        props.text
	    );
	};
	
	var PaginatedPage = function PaginatedPage(WrappedComponent) {
	    var Connect = function Connect(props) {
	        var _props$pathContext = props.pathContext,
	            group = _props$pathContext.group,
	            index = _props$pathContext.index,
	            pageCount = _props$pathContext.pageCount;
	
	        var pathPrefix = 'page';
	        var previousUrl = index - 1 == 1 ? "" : "/" + pathPrefix + "/" + (index - 1).toString();
	        var nextUrl = "/" + pathPrefix + "/" + (index + 1).toString();
	        return Glamor.createElement(
	            "div",
	            null,
	            Glamor.createElement(WrappedComponent, { group: group }),
	            Glamor.createElement(
	                "nav",
	                { className: "navigation posts-navigation", role: "navigation" },
	                Glamor.createElement(
	                    "h2",
	                    { className: "screen-reader-text" },
	                    "Posts navigation"
	                ),
	                Glamor.createElement(
	                    "div",
	                    { className: "nav-links" },
	                    index < pageCount && Glamor.createElement(
	                        "div",
	                        { className: "nav-next" },
	                        Glamor.createElement(NavLink, { url: nextUrl, text: "Older posts" })
	                    ),
	                    index > 1 && Glamor.createElement(
	                        "div",
	                        { className: "nav-previous" },
	                        Glamor.createElement(NavLink, { url: previousUrl, text: "Newer posts" })
	                    )
	                )
	            )
	        );
	    };
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	};
	
	exports.default = PaginatedPage;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-index-js-abca40b8085942832d14.js